<app-form-view [popup]="formPopup">
	<form-title>
		{{title}}
	</form-title>
	<content-area>
		<div class="playlist-form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
			<div fxLayout="row" fxLayoutAlign="center start">
				<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
					<div fxLayout="row" fxLayoutAlign="center center">
						<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
							fxLayoutGap.xs="10px">
							<ng-container *ngIf="action === 'addToPlaylist'">
								<div class="playlist-btn-blk" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
									<!-- <button [disabled]="submitDisable" (click)="submit()" mat-button class="add-btn"
										type="button">{{locale.translate('new_playlist')}}</button> -->
									<div class="add-link" fxLayout="column" fxLayoutAlign="start start">
										<p class="hyperlink" (click)="submit()">{{locale.translate('new_playlist')}}</p>
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="action === 'addPlaylist' || action === 'editPlaylist'">
								<div fxLayout fxLayoutAlign="center start" class="form-container">
									<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
										[formObjectData]="formObjectData" fxLayoutAlign="start stretch" fxLayout.xs="column"
										fxLayoutAlign.xs="start stretch" fxLayoutGap="10px" fxLayoutGap.xs="10px"
										(formObject)="formObjectReader($event)"></app-form-group>
								</div>

								<ng-container *ngIf="this.action === 'addPlaylist'">
									<app-collapsible-area [data]="{title: locale.translate('publish')}"
										[toggle]="{expanded: true, showToggle: true}" color="#fff">
										<div class="visibility-content-area" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayoutGap="10px">
											<span class="visibility-desc">
												{{locale.translate('select_channels_to_publish_if_not_published_desc')}}
											</span>
											<div fxLayout fxLayoutAlign="center start" class="form-container">
												<app-form-group [fieldList]="visibilityField" [formObjectData]="formObjectData"
													[config]="config" fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
													fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
													(formObject)="formObjectReader($event)">
												</app-form-group>
											</div>
										</div>
									</app-collapsible-area>
								</ng-container>
							</ng-container>

							<ng-container *ngIf="action === 'moderatePlaylist'">
								<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
									<ng-container *ngIf="formFields?.length">
										<div class="block-title"> {{ locale.translate('who_are_you_reporting_to') }} </div>
									</ng-container>
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
											[formObjectData]="formObjectData" fxLayoutAlign="start stretch" fxLayout.xs="column"
											fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
											(formObject)="formObjectReader($event)">
										</app-form-group>
									</div>
								</div>
							</ng-container>

							<ng-container *ngIf="action === 'addToPlaylist'">

								<div class="playlist">
									<div class="playlist-list" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
										<ng-container
											*ngFor="let playListData of list; trackBy: gfService.trackByID.bind({'key': 'resourceID'})">
											<!---3rd issue-->
											<div class="playlist-item" fxLayout="row" fxLayoutAlign="space-between center" fxLayout="8px"
												[ngClass]="{ 'processing': playListData?.deleting}">
												<div class="playlist-title">
													{{playListData.title}}
												</div>
												<div>
													<!-- <button [disabled]="playListData.disable" (click)="addToPlaylist(playListData)" mat-button
														class="add-btn" type="button">{{locale.translate('add')}}</button> -->
													<p class="hyperlink" (click)="addToPlaylist(playListData)">{{locale.translate('select')}}</p>
												</div>
											</div>
										</ng-container>
									</div>
									<ng-container *ngIf="list.length === 0 && !popupRef?.componentInstance?.popupLoader">
										<div class="no-data" fxLayout="row" fxLayoutAlign="center center">
											<p>
												{{locale.translate('you_have_not_created_playlist')}}
											</p>
										</div>
									</ng-container>

								</div>
							</ng-container>

							<ng-container *ngIf="action === 'addPlaylistItem'">
								<ng-container
									*ngFor="let resource of selectedResources; trackBy: gfService.trackByID.bind({'key': 'resourceID'});let resourceIndex = index">

									<div class="updates-content fx-column fx-start-stretch">

										<div class="card-block fx-column fx-start-stretch">
											<ng-container
												*ngIf="!['playlist', 'answer','internalEvent', 'externalEvent'].includes(resource?.resourceType?.key)">
												<app-content-image-card [record]="resource" [type]="'minimal'"
													(remove)="removeResource(resourceIndex)">
												</app-content-image-card>
											</ng-container>
											<ng-container *ngIf="resource?.resourceType?.key === 'answer'">
												<app-question-card [type]="'minimal'" [data]="resource"
													(remove)="removeResource(resourceIndex)">
												</app-question-card>
											</ng-container>
											<ng-container *ngIf="['internalEvent', 'externalEvent'].includes(resource?.resourceType?.key)">
												<app-event-card [type]="'minimal'" [data]="resource" (remove)="removeResource(resourceIndex)">
												</app-event-card>
											</ng-container>
										</div>
									</div>

									<!-- <app-content-image-card [type]="'minimal'" [record]="resource"
										(remove)="removeResource(resourceIndex)"></app-content-image-card> -->

									<!-- <div class="resource-search-card" fxLayout="row" fxLayoutAlign="start stretch">

										<ng-container *ngIf="![null, undefined, ''].includes(resource.thumbnail)">
											<div fxFlex="0 0 90px" class="resource-thumbnail">
												<div class="thumbnail">
													<img [src]="resource.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')">
													<ng-container *ngIf="resource?.format">
														<div class="img-overlay" fxLayout="row" fxLayoutAlign="center center">
															<div class="format-icon" fxLayout="row" fxLayoutAlign="center center">
																<ng-container *ngIf="resource?.format === 'video'">
																	<mat-icon svgIcon="video_camera">
																	</mat-icon>
																</ng-container>
																<ng-container *ngIf="resource?.format === 'audio'">
																	<mat-icon svgIcon="audio_headphone">
																	</mat-icon>
																</ng-container>
																<ng-container *ngIf="resource?.format === 'page'">
																	<mat-icon svgIcon="pages">
																	</mat-icon>
																</ng-container>
																<ng-container *ngIf="resource?.format === 'link'">
																	<mat-icon svgIcon="external_link">
																	</mat-icon>
																</ng-container>
																<ng-container *ngIf="resource?.format === 'document'">
																	<mat-icon svgIcon="document">
																	</mat-icon>
																</ng-container>
																<ng-container *ngIf="resource?.format === 'image'">
																	<mat-icon svgIcon="image_collection"></mat-icon>
																</ng-container>
															</div>
														</div>
													</ng-container>
												</div>
											</div>
										</ng-container>
										<div class="search-card-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
											fxLayoutAlign="start stretch" fxLayoutGap="4px">
											<div fxLayout="row" fxLayoutAlign="start start">
												<div class="sub-txt-patch">
													{{resource.type}}</div>
											</div>
											<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
												<p class="card-title" fxFlex="1 1" fxFlex.xs="auto">
													{{resource.title}}</p>
											</div>
										</div>

										<div class="resource-item-btn">
											<button mat-icon-button (click)="removeResource(resourceIndex)">
												<mat-icon>close
												</mat-icon>
											</button>
										</div>
									</div> -->
								</ng-container>
								<div fxLayout fxLayoutAlign="center start" class="form-container">
									<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
										[formObjectData]="formObjectData" fxLayoutAlign="start stretch" fxLayout.xs="column"
										fxLayoutAlign.xs="start stretch" fxLayoutGap="10px" fxLayoutGap.xs="10px"
										(formObject)="formObjectReader($event)"></app-form-group>
								</div>
							</ng-container>

							<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="8px">
								<app-alert id="playlistAlert"></app-alert>
								<ng-container
									*ngIf="['addPlaylist', 'editPlaylist', 'moderatePlaylist', 'addPlaylistItem'].includes(action)">
									<div class="playlist-btn-blk" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
											type="button">
											{{(['addPlaylist', 'moderatePlaylist', 'addPlaylistItem'].includes(action)) ?
											locale.translate('ok') :
											locale.translate('update')}}
										</button>
										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
									</div>
								</ng-container>
								<!-- <ng-container *ngIf="action === 'addToPlaylist'">
									<div class="playlist-btn-blk" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
										<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
											type="button">{{locale.translate('new_playlist')}}</button>
									</div>
								</ng-container> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</content-area>
</app-form-view>
